import { render, staticRenderFns } from "./OnlyWarehousing.vue?vue&type=template&id=1e922b9e&scoped=true&"
import script from "./OnlyWarehousing.vue?vue&type=script&lang=js&"
export * from "./OnlyWarehousing.vue?vue&type=script&lang=js&"
import style0 from "./OnlyWarehousing.vue?vue&type=style&index=0&id=1e922b9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e922b9e",
  null
  
)

export default component.exports